import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PageResponse} from '../../../shared/commons/page-response';

@Injectable({providedIn: 'root'})
export class TasLogService {
  private readonly http = inject(HttpClient);

  search(params: Record<string, string | number>): Observable<PageResponse<any>> {
    return this.http.get<PageResponse<any>>('/api/tas-logs', {params: params as any});
  }
}
